import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CategoryEntrance } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';
import { LinkComponent } from '../../../@shared/routing/link/link.component';
import { ImageComponent } from '../../../@shared/image/image/image.component';
import { SpotHeadlineComponent } from '../spot-headline/spot-headline.component';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-category-entrance',
    templateUrl: './category-entrance.component.html',
    styleUrls: ['./category-entrance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, SpotHeadlineComponent, NgFor, ImageComponent, LinkComponent, SvgIconComponent]
})
export class CategoryEntranceComponent {
    public static readonly ref: string = 'categoryEntrances';

    @HostBinding('attr.style')
    public get valueAsStyle(): SafeStyle | undefined {
        if (this.data) {
            return this.sanitizer.bypassSecurityTrustStyle(`--num-of-entrances: ${this.data.entrances.length}`);
        }

        return;
    }

    @Input()
    public data: CategoryEntrance;

    constructor(private sanitizer: DomSanitizer) {}
}
